var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.976 12.191c-1.032-1.262-1.76-1.905-1.76-5.387 0-3.188-1.628-4.324-2.968-4.875-.178-.074-.346-.242-.4-.424C8.613.705 7.954 0 7.078 0S5.543.705 5.31 1.505c-.054.185-.222.35-.4.424-1.341.552-2.968 1.684-2.968 4.875-.002 3.482-.73 4.125-1.762 5.387-.427.524-.053 1.309.695 1.309h12.41c.744 0 1.116-.788.69-1.309zM9.65 13.5v.643c0 1.42-1.152 2.571-2.572 2.571-1.42 0-2.572-1.151-2.572-2.571V13.5",
    transform: "translate(-1300 -20) translate(1301 21) translate(0 .214)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b9de87bd53d563c9e447f6a13c4b7aac.svg";
export { ForwardRef as ReactComponent };